/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step2description1Inputs */

const he_extension_step2description1 = /** @type {(inputs: Extension_Step2description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המשיכו לגלוש כרגיל באתר KSP.co.il`)
};

const en_extension_step2description1 = /** @type {(inputs: Extension_Step2description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue browsing KSP.co.il as usual`)
};

/**
* | output |
* | --- |
* | "Continue browsing KSP.co.il as usual" |
*
* @param {Extension_Step2description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step2description1 = /** @type {((inputs?: Extension_Step2description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step2description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step2description1(inputs)
	return en_extension_step2description1(inputs)
});
export { extension_step2description1 as "extension_step2Description" }